import { motion } from 'framer-motion';

import { iconsSources } from '../../helpers/icons';

import styles from './Photo.module.css';
import noLogoDefault from '../../assets/images/channel-none.png';
import { hideNumber } from '../../helpers/titreHelper';

export const Photo = ({ message, rotateSign, startDutation }) => {
  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel] || noLogoDefault;
  };

  const srcAvatar =
    (message?.image !== '1' && message?.image) ||
    iconsSources[message?.channel];

  return (
    <div className={styles.photo} key={message.id}>
      <motion.div
        initial={{ left: '65rem', top: '45rem', scale: 1.6 }}
        animate={{
          left: '120rem',
          top: '5rem',
          scale: 1,
          transition: { duration: 0.5, delay: 1.2 },
        }}
        exit={{ x: '50vw', transition: { duration: 1, delay: 0 } }}
        className={styles.avatarBlock}
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.7 }}
          className={styles.avatar}
        >
          <img src={srcAvatar} alt={''} onError={errorHandler} />
        </motion.div>

        <motion.div
          initial={{ maskPosition: '100% 100%' }}
          animate={{ maskPosition: '0% 100%' }}
          transition={{ duration: 0.5 }}
          className={styles.author}
        >
          {message?.author || hideNumber(message?.senderNumber)}
        </motion.div>
      </motion.div>

      <motion.div
        initial={{ scale: 1 }}
        animate={{ scale: 1.1, transition: { duration: 7, delay: 4.3 } }}
        exit={{ x: '100vw', transition: { duration: 0.5, delay: 0 } }}
        className={styles.attachWrapper}
      >
        <motion.div
          initial={{ opacity: 0, x: message?.attachments[1]?.url ? '50%' : 0 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{
            opacity: { duration: 1, delay: 1.7 },
            x: {
              duration: 1,
              delay: 2.7,
            },
          }}
          className={styles.attachBlock}
        >
          <img
            src={message?.attachments[0].url}
            alt={''}
            className={styles.attach}
          />
        </motion.div>

        {message?.attachments[1]?.url && (
          <motion.div
            initial={{ opacity: 0, x: '-50%' }}
            animate={{ opacity: 1, x: 0 }}
            transition={{
              opacity: { duration: 1, delay: 2.5 },
              x: {
                duration: 1,
                delay: 2.7,
              },
            }}
            className={styles.attachBlock1}
            style={{ zIndex: '-1' }}
          >
            <div style={{ position: 'relative', width: '100%' }}>
              <motion.div
                initial={{ opacity: 1 }}
                animate={{ opacity: 0 }}
                transition={{ duration: 1.2, delay: 3.7, ease: 'easeInOut' }}
                className={styles.poster}
              />
              <img
                src={message?.attachments[1]?.url}
                alt={''}
                className={styles.attach}
              />
            </div>
          </motion.div>
        )}
      </motion.div>
    </div>
  );
};
